import type { Product } from '../type';

const initState: {
  productModuleId: number | null;
  selecterElement: any;
  isMessage: boolean;
  isOpenPopup: boolean;
  isLoading: boolean;
  isRefresh: boolean;
  query: String;
  list: Product[];
  queryList: Product[];
  cachedQueryList: Product[];
  fetched: boolean;
  queryFetched: boolean;
  endCursor: string;
  endCursorQuery: string;
} = {
  productModuleId: null,
  selecterElement: null,
  isMessage: false,
  isOpenPopup: false,
  isLoading: false,
  isRefresh: false,
  query: '',
  list: [],
  queryList: [],
  cachedQueryList: [],
  fetched: false,
  queryFetched: false,
  endCursor: '',
  endCursorQuery: '',
};

export default initState;
